const _routes = {
  report: {
    preview: "/report/preview/:reportId",
    previewWithId: (id) => `/report/preview/${id}`
  },

  appointments: {
    preview: "/appointments/preview/:appointmentId",
    previewWithId: (id) => `/appointments/preview/${id}`
  }
  ,
  patient:{
    details:'/patient/detail/:uhid'
  },

  hospital:{
    analytics:"/hospital/analytics/:uhid"
  },

  authentication: {
    login: "/login",
    resetPassword: "/resetPassword",
    forgotPassword: "/forgotPassword",
    verification: "/verification"
  },

  profile: {
    myProfile: "/profile",
  },

  userProfile: {
    myProfile: "/userProfile",
  },

  user: {
    details: "/user/details/:userId",
    detailsWithId: (id) => `/user/details/${id}`
  },
  teleUser: {
    details: "/user/details",
    detailsWithId: (id) => `/user/details/${id}`
  },
  audit:{
    list:"/audit",
    billing: "/billingAudit",
    teleradiologist: "/teleradiologistAudit",
    teleradiologistPayouts: "/teleradiologistPayouts"
  },
  billing:{
    list:"/billing",
    packageList: '/package',
    discountNoti: "/discountNotification",
    invoice: '/invoice',
    previewInvoice: "/invoice/preview/:appointmentId",
    previewInvoiceWithId: (id) => `/invoice/preview/${id}`,
    editInvoice: "/invoice/edit/:appointmentId",
    editInvoiceWithId: (id) => `/invoice/edit/${id}`,
    cancelInvoice: "/invoice/cancel/:appointmentId",
    cancelInvoiceWithId: (id) => `/invoice/cancel/${id}`,
    refundInvoice: "/invoice/refund/:appointmentId",
    refundInvoiceWithId: (id) => `/invoice/refund/${id}`,
  },
  investigation: {
    edit: '/addInvestigation',
  },
  settings: {
    reports: "/settings/reports",
    machines: "/settings/machines",
    pacs: "/settings/pacs",
    caseTiming: "/settings/caseTiming",
    modalityPrice: "/settings/teleHospitalCredits",
    addEditModalityPricing: "/settings/addEditTeleHospitalCredits",
    teleServicePrice: "/settings/teleServicePrice",
    pricing: "/settings/pricing",
    addEditCreditForCaseToCase: "/settings/addEditCreditForCaseToCase",
    addEditAddOns: "/settings/addEditAddOns",
    addEditExtraStorage: "/settings/addEditExtraStorage",
  }
}

export {
  _routes
}
